<template>
  <div>
    <div class="text-start pt-1 mb-2">
      <el-radio-group v-model="field.is_global_variable">
        <el-radio-button :label="false">Custom Field</el-radio-button>
        <el-radio-button :label="true">Global Variable</el-radio-button>
      </el-radio-group>
    </div>

    <el-form label-position="right" v-if="!field.is_global_variable">
      <title-and-description :field="field" />
      <el-row type="flex" :gutter="15">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="form-group">
            <el-form-item class="w-full">
              <div class="flex items-start w-full gap-3">
                <div class="flex items-start flex-col w-1/2 gap-1 justify-start">
                  <div class="flex itesm-center justify-start w-full">
                    <label class="text-lightGray text-xs 2xl:!text-sm font-normal">
                      No of Rows Required?
                    </label>
                    <span class="text-red-500">*</span>
                  </div>
                  <div class="w-full">
                    <el-input
                      class="w-full"
                      type="number"
                      min="3"
                      resize="none"
                      @change="checkMaxMinLen"
                      v-model="field.validations.rows"
                      placeholder="Enter Number Of Rows"
                    ></el-input>
                    <p v-if="maxMinErr" style="color: red; font-size: 14px">
                      {{ maxMinErrMsg }}
                    </p>
                  </div>
                </div>
                <div class="w-1/2">
                  <el-col>
                    <field-attributes :field="field" />
                  </el-col>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <div>
        <div>
          <is-field-required :field="field" class="field-required" />
        </div>
        <el-col :span="24">
          <div class="icon-dropdown-selection flex items-center !gap-3">
            <span
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Icon
            </span>
            <el-button type="text" @click="iconPickerdialogVisible = true">
              <div class="d-flex align-center menu-icon !gap-2">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus !text-brand-500"></i>
              </div>
            </el-button>
          </div>
        </el-col>
      </div>
    </el-form>
    <el-form label-position="right" v-if="field.is_global_variable">
      <el-row>
        <el-col>
          <div class="form-group">
            <el-form-item>
              <div class="flex items-start justify-center flex-col gap-2">
                <div>
                  <label
                    class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
                  >
                    Global Variable
                  </label>
                </div>
                <div class="w-full">
                  <el-select
                    class="w-full"
                    v-model="field.global_variable_id"
                    @change="setGlobalVariable"
                  >
                    <el-option
                      v-for="(globalVariable, index) of allGlobalVariables"
                      :key="index"
                      :label="globalVariable.label"
                      filterable
                      :value="globalVariable._id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <is-field-required :field="field" class="field-required" />
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
  import { fetchGlobalVariables } from '@/repo/globalVariables';
  import { mapGetters } from 'vuex';
  export default {
    name: 'templates-formComponents-MultiLineText',
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
      IsFieldRequired: () => import('./IsFieldRequired'),
      FieldFilledBy: () => import('./FieldFilledBy'),
      Placeholder: () => import('./Placeholder'),
      FieldAttributes: () => import('./FieldAttributes'),
    },
    props: ['field'],
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile', 'getIsRSOpen']),
      allGlobalVariables() {
        return this.getAllGlobalVariables ? this.getAllGlobalVariables.data || [] : [];
      },
    },
    mounted() {
      this.fetchGlobalVaribales();
      if (this.field && this.field.icon_name) {
        this.templateIconPath = this.field.icon_name;
      }
    },
    data() {
      return {
        rowsOptions: [1, 2, 3, 4, 5],
        maxMinErrMsg: '',
        maxMinErr: false,
        iconPickerdialogVisible: false,
        getAllGlobalVariables: null,
        templateIconPath: 'dashboard',
      };
    },
    methods: {
      closeSelectIcon() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.templateIconPath = icon;
        this.$set(this.field, 'icon_name', icon);
        this.iconPickerdialogVisible = false;
      },
      checkMaxMinLen() {
        if (this.field.validations && this.field.validations.rows) {
          const maxlength = this.field.validations.rows;
          if (maxlength < 3) {
            this.field.validations.rows = 3;
            this.maxMinErrMsg = 'Number Rows value should not less than 3';
            this.maxMinErr = true;
          } else {
            this.maxMinErr = false;
          }
        }
      },
      async fetchGlobalVaribales() {
        let params = {
          get_all: true,
          input_type: this.field.input_type,
        };
        this.getAllGlobalVariables = await fetchGlobalVariables(params);
      },
      setGlobalVariable() {
        let globalVariable = this.allGlobalVariables.find(
          (x) => x._id == this.field.global_variable_id
        );
        this.field.label = globalVariable.label;
        this.field.description = globalVariable.description;
        this.field.validations.rows = globalVariable.rows;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .red-asterisk {
    position: relative;
    right: 10px;
    bottom: 2px;
  }
</style>
